import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { sortByRecentYear } from "../../../utils/sortArray";

export const useGetChampionsTeams = ()=>{
            const [championsFromTournament, setChampionsFromTournament] = useState([])
            const [tournamentInfo, setTournamentInfo] = useState({})
            const location = useLocation()
            const idTournament = location.pathname.split('/')?.[2]
            console.log('location', location.pathname.split('/')?.[2])
            useEffect(()=>{
            if(!idTournament) return
        const urlToFetchMatchesByTournament = 'https://web-production-58ed.up.railway.app/api/dt/get/torneos';
        axios.get(urlToFetchMatchesByTournament).then(res =>{
            const tournaments = res.data?.torneos
            const selectedTournament = tournaments?.find(tournament => tournament?._id === idTournament)
            setTournamentInfo(selectedTournament)
            setChampionsFromTournament( sortByRecentYear(selectedTournament?.campeones))
            console.log('selected', selectedTournament)

        }).catch(e => console.log('error', e))

        },[idTournament])

        return{
            championsFromTournament,
            tournamentInfo
        }
}